interface LineBreakProps {
    numLines: number;
}

export default function LineBreak({ numLines }: LineBreakProps) {
    const breakArray = [];
    for (let i = 0; i < numLines; i++) {
        breakArray.push(<br key={i} data-testid="line-break" />);
    }
    return <>{breakArray}</>;
}
